import { useEffect, useState } from "react";
import styled from "styled-components";

const BlinkingDot = styled.div`
  height: 11px;
  width: 11px;
  border-radius: 50%;
  background-color: ${(props) => (props.status === "up" ? "green" : "red")};
  animation: ${(props) =>
    props.status === "up" ? "blink 40ms infinite alternate" : "none"};
  animation-delay: ${() => `${Math.random() * 2000}ms`};

  @keyframes blink {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0.1;
    }
  }
`;

const StatusCard = ({ status, lastRun, service, data, errorInfo }) => {
  const [isOtherInfoVisible, setIsOtherInfoVisible] = useState(false);
  const [isErrorInfoVisible, setIsErrorInfoVisible] = useState(false);

  const toggleOtherInfoVisibility = () => {
    setIsOtherInfoVisible((prev) => !prev);
  };

  const toggleErrorInfoVisibility = () => {
    setIsErrorInfoVisible((prev) => !prev);
  };

  return (
    <div
      style={{
        width: "100%",
        backgroundColor: "white",
        borderRadius: "8px",
        paddingTop: "16px",
        paddingBottom: "16px",
        paddingLeft: "24px",
        paddingRight: "34px",
        boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
        marginBottom: "16px",
      }}
    >
      {/* Top Row: Service Name, Status, and Last Run */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: "8px",
          cursor: "pointer",
        }}
        onClick={() => {
          toggleErrorInfoVisibility();
        }}
      >
        {/* Left: Service Name */}
        <div
          style={{
            fontSize: "1rem",
            fontWeight: "600",
            color: "#333",
            cursor: "pointer",
          }}
          onClick={() => {
            toggleOtherInfoVisibility();
          }}
        >
          {service}
        </div>

        {/* Center: Last Run */}
        <div style={{ fontSize: "0.875rem", color: "#666" }}>
          {lastRun && <span>Last Triggered: {lastRun}</span>}
        </div>

        {/* Right: Blinking Indicator */}
        <div>
          <BlinkingDot status={status} />
        </div>
      </div>

      {/* Other Info Section */}
      {isOtherInfoVisible && data && (
        <div
          style={{
            fontSize: "0.875rem",
            color: "#555",
            marginTop: "8px",
            lineHeight: "1.5",
          }}
        >
          {Object.entries(data).map(([key, value]) => (
            <div key={key}>
              <strong>{key}:</strong> {value}
            </div>
          ))}
        </div>
      )}
      {isErrorInfoVisible && errorInfo && (
        <div
          style={{
            fontSize: "0.875rem",
            color: "#555",
            marginTop: "8px",
            lineHeight: "1.5",
          }}
        >
          {errorInfo}
        </div>
      )}
    </div>
  );
};

export default StatusCard;
